import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "margin-top-bottom--half padding-left--2x" }
const _hoisted_2 = { class: "padding-left--2x" }

import { checkmark } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  name: 'ExerciseListItem',
  props: {
  exercise: {
    type: Object,
    required: true,
  },
  isCompleted: {
    type: Boolean,
    default: false,
  },
  isMissed: {
    type: Boolean,
    default: false,
  },
},
  emits: ["view", "complete"],
  setup(__props, { emit }) {

const props = __props




function getExercise() {
  emit("view");
}

function completed() {
  emit("complete");
}

return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, {
    class: _normalizeClass('row row-bgcolor--alternate exercise-list-item')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, {
        size: "10",
        class: _normalizeClass(`ion-text-left complete--${__props.isCompleted}`),
        onClick: getExercise
      }, {
        default: _withCtx(() => [
          _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.exercise.title), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.exercise.training || __props.exercise.training_amount), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_col, {
        size: "2",
        class: _normalizeClass(`align-items--center padding--0 complete--${__props.isCompleted}`)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            expand: "full",
            class: "btn--full-height margin--none",
            disabled: __props.isCompleted || __props.isMissed,
            onClick: completed
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _unref(checkmark) }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})